var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"keypress"},[(_vm.showOptions)?_c('div',{staticClass:"options"},_vm._l((_vm.keys),function(option,key){return _c('span',{key:key},[_c('strong',{domProps:{"textContent":_vm._s(key)}}),_vm._v(" = "+_vm._s(option)+" ")])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }